"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterType = void 0;
var ParameterType;
(function (ParameterType) {
    ParameterType["AutoComplete"] = "autocomplete";
    ParameterType["Confirm"] = "confirm";
    ParameterType["Text"] = "text";
    ParameterType["Select"] = "select";
    ParameterType["MultiSelect"] = "multiselect";
    ParameterType["AutoCompleteMultiSelect"] = "autocompleteMultiselect";
    ParameterType["Number"] = "number";
    ParameterType["Password"] = "password";
})(ParameterType = exports.ParameterType || (exports.ParameterType = {}));
//# sourceMappingURL=Parameter.js.map